import * as React from "react";
import { Button, Empty, Input, Modal } from "antd";
import SpinnerPopUp from "../../spinner/SpinnerPopUp";
import SelectionTable from "../../usageComponents/selectionTable/SelectionTable";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { SEARCH_VIEW_USAGES } from "../../../Consts";
import type { IMatchSearchModalConfig } from "./AiSearchTypes";

const MatchSearchModal: React.FC<IMatchSearchModalConfig> = ({
    open,
    title,
    fields,
    searchResults,
    searchResultsTableData,
    noResultsText,
    componentInstance,
    onClose,
    onSearch,
    onSelectResult,
    onOpenWorkDetails,
    onOpenProductDetails
}) => {
    const [values, setValues] = React.useState<{ [name: string]: string }>({});
    const [hasSearched, setHasSearched] = React.useState(false);
    const [isSearching, setIsSearching] = React.useState(false);
    const [expandedResults, setExpandedResults] = React.useState<number[]>([]);
    const [expandAll, setExpandAll] = React.useState(false);

    React.useEffect(() => {
        if (!open) {
            setValues({});
            setHasSearched(false);
            setIsSearching(false);
            setExpandedResults([]);
            setExpandAll(false);
        }
    }, [open]);

    React.useEffect(() => {
        setIsSearching(false);
        setExpandedResults([]);
        setExpandAll(false);
    }, [searchResults]);

    const handleSearch = () => {
        setHasSearched(true);
        setIsSearching(true);
        onSearch(values);
    };

    const toggleExpandedResult = (resultIndex: number) => {
        setExpandedResults(previous => previous.includes(resultIndex)
            ? previous.filter(index => index !== resultIndex)
            : [...previous, resultIndex]);
    };

    const toggleExpandAllResults = () => {
        const shouldExpandAll = !expandAll;
        setExpandAll(shouldExpandAll);
        setExpandedResults(shouldExpandAll ? (searchResults || []).map((_, index) => index) : []);
    };

    return <Modal
        title={title}
        open={open}
        onCancel={onClose}
        footer={null}
        width={1200}
        styles={{ body: { maxHeight: "calc(100vh - 128px)", overflowY: "auto" } }}
        destroyOnHidden
    >
        <div className="workMatchSearchFields">
            {fields.map(field => (
                <Input
                    key={field.name}
                    placeholder={field.placeholder}
                    value={values[field.name] || ""}
                    onChange={event => setValues({ ...values, [field.name]: event.target.value })}
                    onPressEnter={handleSearch}
                />
            ))}
            <Button type="primary" className="workMatchSearchBtn" loading={isSearching} onClick={handleSearch}>Search</Button>
        </div>
        <div className="workMatchSearchResults">
            {!hasSearched ? (
                <Empty description="Enter search criteria and click Search" />
            ) : isSearching ? (
                <div className="workMatchSearchLoading"><SpinnerPopUp visible /></div>
            ) : !searchResults || searchResults.length === 0 ? (
                <Empty description={noResultsText} />
            ) : (
                <SelectionTable
                    searchResultsTableData={searchResultsTableData}
                    tableContents={searchResults}
                    componentInstance={componentInstance}
                    repertoireSection={SEARCH_VIEW_USAGES}
                    hideModal={hideModal}
                    updatePagination={() => { }}
                    onSelectResult={onSelectResult}
                    expandedResults={expandedResults}
                    expandResult={toggleExpandedResult}
                    expandAll={expandAll}
                    expandAllResults={toggleExpandAllResults}
                    getWorkDetails={onOpenWorkDetails}
                    getProductDetails={onOpenProductDetails}
                />
            )}
        </div>
    </Modal>
};

export default MatchSearchModal;
